/* ============================================
   AKV STUDIOS — ADAPTIVE HEADER
   1. Spacer for fixed header
   2. Light/dark detection
   3. Mobile top bar
   4. Branded left slide-out drawer
   ============================================ */

(function() {
  'use strict';

  var HEADER_SELECTOR = '.header-wrapper';
  var LIGHT_CLASS = 'is-over-light';
  var spacer = null;
  var overlay = null;

  /* ---- SPACER ---- */
  function createSpacer() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    if (header.classList.contains('header-wrapper--overlay')) return;
    spacer = document.querySelector('.akv-header-spacer');
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'akv-header-spacer';
      var headerSection = header.closest('[data-section-id]') || header.parentElement;
      if (headerSection && headerSection.nextSibling) {
        headerSection.parentNode.insertBefore(spacer, headerSection.nextSibling);
      } else if (headerSection) {
        headerSection.parentNode.appendChild(spacer);
      }
    }
    updateSpacerHeight();
  }

  function updateSpacerHeight() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header || !spacer) return;
    if (header.classList.contains('header-wrapper--overlay')) {
      spacer.style.height = '0px';
      return;
    }
    spacer.style.height = header.offsetHeight + 'px';
  }

  /* ---- DRAWER ---- */
  function createDrawerElements() {
    var slideNavOverflow = document.querySelector('.slide-nav__overflow');
    if (!slideNavOverflow) return;

    /* Overlay */
    if (!document.querySelector('.akv-drawer-overlay')) {
      overlay = document.createElement('div');
      overlay.className = 'akv-drawer-overlay';
      document.body.appendChild(overlay);
      overlay.addEventListener('click', function() { closeDrawer(); });
    } else {
      overlay = document.querySelector('.akv-drawer-overlay');
    }

    /* Drawer header with logo + close button */
    if (!slideNavOverflow.querySelector('.akv-drawer-header')) {
      var whiteLogo = document.querySelector('.logo--inverted img.medium-up--hide');
      if (!whiteLogo) whiteLogo = document.querySelector('.logo--inverted img');
      var logoSrc = whiteLogo ? whiteLogo.getAttribute('src') : '';

      var drawerHeader = document.createElement('div');
      drawerHeader.className = 'akv-drawer-header';
      drawerHeader.innerHTML =
        '<a href="/" class="akv-drawer-logo">' +
          '<img src="' + logoSrc + '" alt="AKV Studios" />' +
        '</a>' +
        '<button class="akv-drawer-close" aria-label="Close menu">' +
          '<svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>';

      slideNavOverflow.insertBefore(drawerHeader, slideNavOverflow.firstChild);

      drawerHeader.querySelector('.akv-drawer-close').addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    }

    /* Drawer footer with socials */
    if (!slideNavOverflow.querySelector('.akv-drawer-footer')) {
      var drawerFooter = document.createElement('div');
      drawerFooter.className = 'akv-drawer-footer';
      drawerFooter.innerHTML =
        '<div class="akv-drawer-footer-text">Professional video editing assets</div>' +
        '<div class="akv-drawer-socials">' +
          '<a href="https://www.instagram.com/akvstudios/" target="_blank" aria-label="Instagram">' +
            '<svg viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path></svg>' +
          '</a>' +
          '<a href="https://www.youtube.com/@akvstudios1" target="_blank" aria-label="YouTube">' +
            '<svg viewBox="0 0 24 24"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29.94 29.94 0 0 0 1 12a29.94 29.94 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29.94 29.94 0 0 0 23 12a29.94 29.94 0 0 0-.46-5.58z"></path><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"></polygon></svg>' +
          '</a>' +
        '</div>';

      slideNavOverflow.appendChild(drawerFooter);
    }

    /* Remove any old close buttons that aren't ours */
    var oldCloseButtons = slideNavOverflow.querySelectorAll('.akv-drawer-close');
    if (oldCloseButtons.length > 1) {
      for (var i = 1; i < oldCloseButtons.length; i++) {
        oldCloseButtons[i].remove();
      }
    }
  }

  function openDrawer() {
    var slideNavOverflow = document.querySelector('.slide-nav__overflow');
    if (!slideNavOverflow) return;
    slideNavOverflow.classList.add('js-menu--is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var slideNavOverflow = document.querySelector('.slide-nav__overflow');
    if (!slideNavOverflow) return;
    slideNavOverflow.classList.remove('js-menu--is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  /* ---- MOBILE TOP BAR ---- */
  function createMobileTopBar() {
    if (document.querySelector('.akv-mobile-topbar')) return;
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    var siteHeader = header.querySelector('.site-header');
    if (!siteHeader) return;

    var cartBubble = document.querySelector('.cart-link__bubble-num');
    var cartCount = cartBubble ? cartBubble.textContent.trim() : '';

    var whiteLogo = document.querySelector('.logo--inverted img.medium-up--hide');
    if (!whiteLogo) whiteLogo = document.querySelector('.logo--inverted img');
    var logoSrc = whiteLogo ? whiteLogo.getAttribute('src') : '';

    var darkLogo = document.querySelector('.logo--has-inverted img.medium-up--hide');
    if (!darkLogo) darkLogo = document.querySelector('.logo--has-inverted img');
    var darkLogoSrc = darkLogo ? darkLogo.getAttribute('src') : '';

    var bar = document.createElement('div');
    bar.className = 'akv-mobile-topbar';
    bar.innerHTML =
      '<div class="akv-mob-left">' +
        '<button class="akv-mob-icon akv-mob-menu" type="button" aria-label="Menu">' +
          '<svg viewBox="0 0 24 24"><path d="M3 6h18M3 12h18M3 18h18"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="akv-mob-center">' +
        '<a href="/">' +
          '<img src="' + logoSrc + '" alt="AKV Studios" class="akv-mob-logo-white" />' +
          (darkLogoSrc ? '<img src="' + darkLogoSrc + '" alt="AKV Studios" class="akv-mob-logo-dark" style="display:none" />' : '') +
        '</a>' +
      '</div>' +
      '<div class="akv-mob-right">' +
        '<a href="/cart" class="akv-mob-icon akv-mob-cart js-drawer-open-cart js-no-transition" aria-label="Cart" style="position:relative">' +
          '<svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '<span class="akv-mob-cart-badge">' + (cartCount !== '0' ? cartCount : '') + '</span>' +
        '</a>' +
      '</div>';

    siteHeader.insertBefore(bar, siteHeader.firstChild);

    bar.querySelector('.akv-mob-menu').addEventListener('click', function(e) {
      e.preventDefault();
      var slideNavOverflow = document.querySelector('.slide-nav__overflow');
      if (slideNavOverflow && slideNavOverflow.classList.contains('js-menu--is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    bar.querySelector('.akv-mob-cart').addEventListener('click', function(e) {
      e.preventDefault();
      var existingCartBtn = document.querySelector('.site-nav__thumb-cart');
      if (existingCartBtn) {
        existingCartBtn.click();
      } else {
        var desktopCart = document.querySelector('.js-drawer-open-cart');
        if (desktopCart && desktopCart !== e.currentTarget) {
          desktopCart.click();
        } else {
          window.location.href = '/cart';
        }
      }
    });
  }

  function updateMobileLogo(isLight) {
    var whiteLogo = document.querySelector('.akv-mob-logo-white');
    var darkLogo = document.querySelector('.akv-mob-logo-dark');
    if (whiteLogo && darkLogo) {
      whiteLogo.style.display = isLight ? 'none' : 'block';
      darkLogo.style.display = isLight ? 'block' : 'none';
    }
  }

  /* ---- BACKGROUND DETECTION ---- */
  function getLuminance(r, g, b) {
    var a = [r, g, b].map(function(c) {
      c = c / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  function parseColor(str) {
    if (!str || str === 'transparent' || str === 'rgba(0, 0, 0, 0)') return null;
    var m = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (m) return { r: parseInt(m[1]), g: parseInt(m[2]), b: parseInt(m[3]) };
    return null;
  }

  function isLightElement(el) {
    if (el.dataset && el.dataset.headerTheme === 'light') return true;
    if (el.dataset && el.dataset.headerTheme === 'dark') return false;
    var parent = el.closest('[data-header-theme]');
    if (parent) return parent.dataset.headerTheme === 'light';
    var current = el;
    var maxDepth = 5;
    while (current && maxDepth > 0) {
      var bg = window.getComputedStyle(current).backgroundColor;
      var color = parseColor(bg);
      if (color) return getLuminance(color.r, color.g, color.b) > 0.4;
      current = current.parentElement;
      maxDepth--;
    }
    return false;
  }

  function checkHeader() {
    var header = document.querySelector(HEADER_SELECTOR);
    if (!header) return;
    var sampleY = header.getBoundingClientRect().bottom + 2;
    var sampleX = window.innerWidth / 2;
    var origPE = header.style.pointerEvents;
    header.style.pointerEvents = 'none';
    var el = document.elementFromPoint(sampleX, sampleY);
    header.style.pointerEvents = origPE;
    if (!el) return;
    var section = el.closest('.shopify-section') || el.closest('[data-header-theme]') || el;
    if (section.classList && section.classList.contains('akv-header-spacer')) return;
    var isLight = isLightElement(section);
    header.classList.toggle(LIGHT_CLASS, isLight);
    updateMobileLogo(isLight);
  }

  function syncCartCount() {
    var cartBubble = document.querySelector('.cart-link__bubble-num');
    var mobBadge = document.querySelector('.akv-mob-cart-badge');
    if (cartBubble && mobBadge) {
      var count = cartBubble.textContent.trim();
      mobBadge.textContent = (count === '0') ? '' : count;
    }
  }

  /* ---- WATCH SLIDE NAV STATE ---- */
  function watchSlideNav() {
    var slideNavOverflow = document.querySelector('.slide-nav__overflow');
    if (!slideNavOverflow) return;
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class') {
          var isOpen = slideNavOverflow.classList.contains('js-menu--is-open');
          if (overlay) overlay.classList.toggle('is-visible', isOpen);
          document.body.style.overflow = isOpen ? 'hidden' : '';
        }
      });
    });
    observer.observe(slideNavOverflow, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- EVENTS ---- */
  var ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function() {
        checkHeader();
        ticking = false;
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function() {
    updateSpacerHeight();
    checkHeader();
  }, { passive: true });

  function init() {
    createSpacer();
    createMobileTopBar();
    createDrawerElements();
    watchSlideNav();
    setTimeout(checkHeader, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.ResizeObserver) {
    setTimeout(function() {
      var header = document.querySelector(HEADER_SELECTOR);
      if (header) new ResizeObserver(updateSpacerHeight).observe(header);
    }, 500);
  }

  setInterval(function() {
    checkHeader();
    syncCartCount();
  }, 1500);
})();